import _extends from "@babel/runtime/helpers/extends";
/* eslint-disable max-lines */
import * as React from 'react';
import { createIcon } from '../internal';

// eslint-disable-next-line react/display-name
var IconComponent = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    ref: ref,
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.7.479a.752.752 0 0 0-1.4 0L5.656 4.652a.754.754 0 0 1-.638.476L.69 5.495c-.657.056-.931.874-.44 1.318l3.351 3.035a.76.76 0 0 1 .231.73l-1.014 4.495c-.15.66.574 1.17 1.142.804l3.632-2.344a.75.75 0 0 1 .814 0l3.632 2.345c.568.366 1.292-.144 1.142-.806l-1.014-4.494a.76.76 0 0 1 .23-.73l3.353-3.035c.49-.444.216-1.262-.441-1.318l-4.329-.367a.754.754 0 0 1-.637-.476L8.701.48Z",
    fill: "currentColor"
  }));
});

/**
 * Компоненты иконки <br />
 * Некоторые иконки красятся в любые цвета из палитры, некоторые имеют зафиксированные цвета.<br />
 * Подключение иконки: `import { Star16 } from '@cian/ui-kit/icons';`, <br />
 * где 16 - это размер иконки в пикселях.
 */
export var Star16 = createIcon(IconComponent);